import React, {  useEffect, useRef, useState } from "react";
import ImthyazBannerImg from "../assets/images/imthyaz4.webp";
import BannerBgImg from "../assets/images/bannerimg.jpg";
import ImthyazBannerMobileImg from "../assets/images/imthyazmobile.webp";
import imthyazmobileNew from "../assets/images/imthyazmobileNew.webp"
import Imthyaz2 from "../assets/images/imthyaz2.webp";
import Imthyaz3 from "../assets/images/imthyaz3.png";
import Thumbnail from "../assets/images/Thumbnail.png";
import starIcon from "../assets/images/stars.png";
import sec2 from "../assets/images/sec-2.png";
import achievement1 from "../assets/images/award1.png";
import achievement2 from "../assets/images/award2.png";
import achievement3 from "../assets/images/award3.png";
import CustomButton from "../Components/Button/CustomButton";
import accentureLogo from "../assets/images/clients/accenture.png";
import finfozLogo from "../assets/images/clients/finforz.png";
import buckmanLogo from "../assets/images/clients/buckman.png";
import mg2Logo from "../assets/images/clients/mg2.png";
import cyberLogo from "../assets/images/clients/cyber.png";
import nipponLogo from "../assets/images/clients/nippon.png";
import "./home.css";
import Timeline from "../Components/Timeline/Timeline";
import ReactPlayer from "react-player";
import { CircleCheckBig, CloudAlert, Loader, Pause, Play } from "lucide-react";
import testmonialBg from "../assets/images/testimonialbg.png";
import author from "../assets/images/author.png";
import contactbg from "../assets/images/contactbg.png";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { text } from "framer-motion/client";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const Home = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const timer = setTimeout(() => {
      setStatus("idle");
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  }, [status]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "First name is required.";
    } else if (/\d/.test(formData.name)) {
      newErrors.name = "First name cannot contain numbers.";
    }

    // // Validate last name (no numbers allowed)
    // if (!formData.lastName.trim()) {
    //   newErrors.lastName = "Last name is required.";
    // } else if (/\d/.test(formData.lastName)) {
    //   newErrors.lastName = "Last name cannot contain numbers.";
    // }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be 10 digits.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setStatus("loading");
        const response = await fetch("http://localhost:3000/api/form", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        if (response.ok) {
          const data = await response.json();
          setStatus("success");
          setErrors({});
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });
          console.log("Server response:", data);
        } else {
          console.error("Failed to send form data. Status:", response.status);
          setStatus("error");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setStatus("error");
      }
    }
  };

  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [width]);

  const testimonialData = [
    {
      name: "Amanda Jade",
      designation: "Founder, Vantech Wellness",
      review:
        "Under Imthyaz leadership, businesses thrive, relationships flourish, and the future is always brighter. Working with Imthyaz is truly a transformative and rewarding experience.",
      authorImg: author,
    },
    {
      name: "Michael Carter",
      designation: "CEO, BrightPath Innovations",
      review:
        "Imthyaz’s guidance has been a game-changer for our organization. His ability to craft innovative strategies is unmatched. Partnering with him has been the best decision for our growth.",
      authorImg: author,
    },
    {
      name: "Sophia Reynolds",
      designation: "Co-Founder, Apex Technologies",
      review:
        "Imthyaz brings a unique blend of vision and execution to every project. His leadership inspires teams to achieve extraordinary results beyond expectations.",
      authorImg: author,
    },
    {
      name: "John Doe",
      designation: "CEO, BrightPath Innovations",
      review:
        "Imthyaz’s guidance has been a game-changer for our organization. His ability to craft innovative strategies is unmatched. Partnering with him has been the best decision for our growth.",
      authorImg: author,
    },
    {
      name: "Jackie Chan",
      designation: "CEO, BrightPath Innovations",
      review:
        "Imthyaz’s guidance has been a game-changer for our organization. His ability to craft innovative strategies is unmatched. Partnering with him has been the best decision for our growth.",
      authorImg: author,
    },
  ];

  const settings = {
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    swipeToSlide: true,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 3000, // Ensures continuous scroll
    infinite: true,
    draggable: true,
    pauseOnHover: false,
    verticalSwiping: true,
    cssEase: "linear", // Makes it seamless
  };

  const texts = [
    "எல்லைகள் தொல்லை வானமே இல்லை ",
    "Limits May Bind, But The Sky Is Boundless",
  ];

  const [textIndex, setTextIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered) return;

    const timer = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [isHovered]);

  const journeyRef = useRef(null);
  const awardsRef = useRef(null);
  const expertiseRef = useRef(null);
  const contactRef = useRef(null);



  const [is2kViewed, setIs2kViewed] = useState(window.innerWidth >= 1920 && window.innerWidth <= 2600);

  useEffect(() => {
    const handleResize = () => {
      setIs2kViewed(window.innerWidth >= 1920 && window.innerWidth <= 2600);
    };
  
    // Add event listener
    window.addEventListener("resize", handleResize);
  
    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  console.log(is2kViewed, "hey");
  
  



  return (
    <>
    <Header sectionRef={{journeyRef,awardsRef,expertiseRef,contactRef}} is2kView={is2kViewed}/>
    <div className="text-white font-RedHat overflow-hidden " >
      <section
        className={`min-h-screen   lg:pt-[18vh] md:pt-[10vh ] pt-[20vh] flex flex-row items-start lg:items-center md:items-center justify-between px-10 md:px-50 lg:px-20 xl:px-52 ${is2kViewed && "2xl:px-72"}  `}
        style={{
          // background: width <= 750 ? `url(${ImthyazBannerMobileImg})` : `linear-gradient(86.6deg, rgba(0, 0, 0, 0.84) 0.94%, rgba(0, 0, 0, 0.9) 98.54%), url(${BannerBgImg})`,
          backgroundImage:
            width <= 770
              ? `linear-gradient(80.6deg, rgba(0, 0, 0, 0.5) 0.94%, rgba(0, 0, 0, 0.1) 15.54%), url(${imthyazmobileNew})`
              : `linear-gradient(86.6deg, rgba(0, 0, 0, 0.8) 0.94%, rgba(0, 0, 0, 0.9) 98.54%), url()`,
          backgroundPosition: width <= 770 ? "bottom right" : "left center",
          backgroundSize: width <= 770 ? "250px 500px" : "cover",
          backgroundRepeat: "no-repeat",
          
        }}
      >
        <div className="lg:w-[65%] md:w-[65%] w-full flex flex-col items-start gap-6 ">
          <div className=" max-md:-translate-y-10 top-6 flex flex-col gap-10 ">
            <motion.h3
              initial={{ opacity: 0, translateY: -10 }}
              whileInView={{ opacity: 1, translateY: 0 }}
              transition={{ duration: 1.5 }}
              viewport={{ once: true }}
              className={`text-[1.2rem] ${is2kViewed && "text-[1.5rem]"} `}
            >
              I am Passionate, People Centric,
              <br />
              Guided by Purpose and Playing to my Strength. I am
            </motion.h3>
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 2 }}
              viewport={{ once: true }}
              className={`text-3xl lg:text-[1.6rem] xl:text-5xl font-adelia lg:my-10 w-full leading-loose max-md:-translate-y-7  ${is2kViewed && "2xl:text-7xl"}`}
            >
                       Dr. C Imthyaz<br />
                       <span className="block mt-12 max-md:hidden"></span>Sheriff&nbsp;&nbsp;
            </motion.h2>
            <h6 className="text-white text-base max-md:text-sm max-md:-translate-y-16 lg:text-xl pt-4">
              Founder & CEO <br className="md:hidden" />- Ideassion Group
            </h6>
          </div>
          <ul className="md:grid lg:grid  grid-cols-1 sm:grid-cols-2 gap-4 hidden ">
            {[
              "Serial Entrepreneur",
              "Technocrat",
              "human capital management Architect",
              "Digital Transformation Evangelist",
              "GRC Strategist",
            ].map((item, index) => (
              <li
                className={`flex items-center gap-3 text-base ${is2kViewed && "2xl:text-xl"} capitalize`}
                key={index}
              >
                <img
                  src={starIcon}
                  alt="icon"
                  className="h-5 w-5 lg:h-6 lg:w-6"
                />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8">
            <CustomButton text={"Let's Connect"} sectionRef={contactRef} />
          </div>
        </div>

        {/* Right Section */}
        <div className="w-[35%] lg:flex  hidden mt-8 lg:mt-0 justify-center ">
          <motion.img
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 3 }}
            viewport={{ once: true }}
            src={ImthyazBannerImg}
            alt="Imthyaz Banner"
            className={`xl:max-w-[600px] lg:max-w-[500px] object-right-bottom ${is2kViewed && "2xl:max-w-[60rem]"}`}
          />
        </div>
      </section>

      <section
        className="min-h-[20vh] flex flex-col items-center justify-center"
        style={{
          background:
            "radial-gradient(circle, rgba(25, 25, 145, 0.7) 0%, rgba(25, 25, 145, 0) 50%)",
          backdropFilter: "blur(414px)",
        }}
      >
        <motion.div
          key={textIndex}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="text-center italic text-xl font-semibold"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          dangerouslySetInnerHTML={{
            __html: `&#10077; ${texts[textIndex]} <span class="font-Fleur">&#10078;</span>`,
          }}
        />

        <p></p>
      </section>

      <section className={`section-2 min-h-screen flex flex-col lg:flex-row  justify-center py-10 gap-10 md:px-30 lg:px-20 xl:px-44 ${is2kViewed && "2xl:px-72"}`}>
        <div className="w-full lg:w-[40%] px-10 flex items-center justify-center">
          <img
            src={sec2}
            alt="Section 2"
            className="max-w-full  lg:h-auto xl:h-auto md:h-[400px]"
          />
        </div>
        <div className="w-full lg:w-[60%] flex flex-col gap-2 items-start justify-center  p-10">
          <motion.h3
            initial={{ opacity: 0, translateY: -50 }}
            whileInView={{ opacity: 1, translayteY: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: false }}
            className="text-3xl lg:text-3xl xl:text-4xl  font-bold capitalize leading-snug"
          >
            You have to Build For Where <br /> the world is headed next
          </motion.h3>
          <p className="text-base xl:text-xl leading-relaxed my-1 text-justify">
            As a servant leader at heart, I’ve always believed that fostering an
            environment of collaboration & empowering my team is the key to
            success. Together, we face every challenge with resilience, knowing
            that obstacles are just opportunities in disguise.
            <br /><br />
            With the unwavering work ethic I instilled in myself and my team, we
            have crafted a culture of innovation, where every tenacious effort
            is rewarded and every opportunity is seized.
            <br /><br />
            Progress is the compass that guides us, and we're focused on
            creating digital solutions that pave the way for a sustainable,
            tech-forward future - ensuring we’re always ahead of the curve.
            <br /><br />
            With a vision for what’s next, I’m proud to be leading a digital
            revolution, one bold step at a time. Had it not been for this
            vision, I wouldn't be as determined to make a lasting impact on
            tomorrow’s world. And together, we will.
          </p>
        </div>
      </section>
      <section className="min-h-[20vh] py-10 flex flex-col items-center justify-center ">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="text-center  font-semibold flex items-center"
        >
          <h2 className="text-3xl font-semibold underlined ">
            <span className="font-bold text-4xl"> 20+ Papers</span> Published In
            "
            <span
              // style={{
              //   background:
              //     "linear-gradient(90.19deg, #191991 0.17%, #D8D8FF 53.7%)",
              //   WebkitBackgroundClip: "text",
              //   WebkitTextFillColor: "transparent",
              // }}
              className="font-normal"
            >
              International Journals & Conference
            </span>
            "
          </h2>
        </motion.div>
      </section>
      {/* <section
        className={`h-auto py-20  w-full px-5 md:px-30 lg:px-32 xl:px-20 ${is2kViewed && "2xl:px-80"}` }
        ref={journeyRef}
        style={{
          backgroundImage: "radial-gradient(circle, #191991, #000000,#000000)",
          backgroundSize: "100% 100%", // Adjusts the gradient's size
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
        }}
      >
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center "
        >
          The Journey So Far and Ahead
        </motion.h3>
        <Timeline />
      </section> */}
      <section
        className="h-auto py-10 flex flex-col items-center my-5 "
       ref={awardsRef}
      >
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          // style={{
          //   background:
          //     "linear-gradient(90.19deg, #191991 0.12%, #D8D8FF 53.7%)",
          //   WebkitBackgroundClip: "text",
          //   WebkitTextFillColor: "transparent",
          // }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center"
        >
          Global Recognition for Innovation
        </motion.h3>
        <div className="flex flex-row items-center flex-wrap lg:w-[70%] w-full justify-center gap-20 my-10">
          {[achievement1, achievement2, achievement3].map((obj, index) => {
            return (
              <div className="flex flex-row items-center gap-5">
                <motion.img
                  initial={{ opacity: 0.5, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  viewport={{ once: true }}
                  src={obj}
                  alt="icon"
                  width={300}
                  height={300}
                  className=" "
                />
              </div>
            );
          })}
        </div>
      </section>

      {/* <section
        className="h-fit py-20  flex flex-col items-center justify-center gap-10 md:px-30 lg:px-60 xl:px-44"
        style={{
          background:
            "radial-gradient(circle, rgba(25, 25, 145, 0.7) 0%, rgba(25, 25, 145, 0) 50%)",
          backdropFilter: "blur(414px)",
        }}
      >
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center "
        >
          The Foundation of Our Journey
        </motion.h3>
        <p className="text-base font-normal xl:text-2xl leading-relaxed text-center w-[80%]">
          Are you the next one to join a legacy of excellence and innovation?Are
          you the next one to join a legacy of excellence and innovation?Are you
          the next one to join a legacy of excellence .Are you the next one to
          join a legacy of excellence and innovation?Are you the next one to
          join a legacy of excellence and innovation?Are you the next one to
          join a legacy of excellence .
        </p>
      </section> */}

      <section
        className={`h-fit flex flex-col gap-10 py-20 px-10 md:px-30 lg:px-20 xl:px-44 ${is2kViewed && "2xl:px-80"}`}
        ref={expertiseRef}
        style={{
          background:
            "radial-gradient(circle, rgba(21, 121, 246, 1) 0%, rgba(25, 25, 145, 0) 50%)",
          backdropFilter: "blur(328.1px)",
        }}
      >
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center"
        >
          My Expertise
        </motion.h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-5  place-items-center">
          {[
            {
              id: 1,
              title: "Branding",
              description:
                "As a CEO, he brings expertise in crafting strong and authentic brand identities. With a focus on understanding market dynamics and customer needs, he ensures brands stand out while fostering growth and trust in the competitive business landscape.",
            },
            {
              image: Imthyaz2,
            },
            {
              id: 2,
              title: "Innovation",
              description:
                "Innovation is at the heart of his approach. By staying ahead of industry trends and embracing new technologies, he helps organizations reimagine possibilities, solve complex challenges, and maintain a competitive edge.",
            },
            {
              id: 3,
              title: "Leadership",
              description:
                "With years of experience leading teams to success, he specializes in empowering individuals and building collaborative environments. His leadership style drives innovation, motivates teams, and ensures strategic goals are met with excellence.",
            },
            {
              id: 4,
              title: "GRC Strategist",
              description:
                "He possesses deep expertise in Governance, Risk, and Compliance (GRC). By implementing robust frameworks and ensuring adherence to regulatory standards, he helps organizations mitigate risks, achieve compliance, and drive accountability at every level.",
            },
            {
              id: 5,
              title: "Operational Excellence",
              description:
                "Through streamlined processes and efficient resource management, he ensures organizational objectives are achieved seamlessly. His expertise in operations enhances productivity and aligns execution with strategic goals.",
            },
          ].map((obj, index) => {
            const isImage = index === 1;

            return isImage ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                viewport={{ once: true }}
                className={`flex flex-col items-center justify-end gap-5 border border-transparent h-[336px] bg-[#595985] w-full sm:w-[386px] lg:w-[300px]  ${is2kViewed && "2xl:w-[400px] 2xl:h-[380px]"} md:w-[300px] md:h-[340px] rounded-[20px]`}
                key={index}
              >
                <img
                  src={obj.image}
                  alt="imthyaz.png"
                  className="w-full h-auto rounded-lg"
                />
              </motion.div>
            ) : (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                viewport={{ once: true }}
                className={`flex flex-col items-start justify-center gap-5 border h-[336px] w-full sm:w-[386px] lg:w-[300px]  ${is2kViewed && "2xl:w-[400px] 2xl:h-[380px]"} rounded-[20px] md:w-[300px] md:h-[340px] p-4 `}
                key={index}
                style={{
                  background: "rgba(16, 16, 16, 0.6)",
                  backdropFilter: "blur(108.5px)",
                }}
              >
                <div className="flex flex-row items-center gap-5">
                  <span className="h-10 w-10 rounded-lg flex items-center justify-center bg-[#191991]">
                    {obj.id}
                  </span>
                  <h5 className="font-bold text-base">{obj.title}</h5>
                </div>
                <p className="lg:text-base text-sm font-normal leading-relaxed">
                  {obj.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </section>
      <section className={`h-fit flex flex-col lg:flex-row  justify-center py-20 md:px-30 lg:px-20 xl:px-44 ${is2kViewed && "2xl:px-80"}`}>
        <div className="w-full lg:w-[60%] flex flex-col gap-20 items-start justify-center  p-10">
          <motion.div
            initial={{ opacity: 0, translateY: -50 }}
            whileInView={{ opacity: 1, translayteY: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: false }}
            className="text-3xl lg:text-3xl xl:text-6xl font-bold capitalize leading-relaxed"
          >
            The Driving Force <br /> Behind the Vision
          </motion.div>
          <p className="text-base xl:text-[1.25rem] font-normal leading-relaxed">
            Driven by vision, innovation, and results, Imthyaz Sheriff is a
            dynamic leader with a proven track record of transforming ideas into
            impactful outcomes. As a CEO, He bring expertise in industry,
            fostering growth, empowering teams, and steering organizations
            toward sustainable success.
            <br />
            <br />
            {/* Driven by vision, innovation, and results, Imthyaz Sheriff is a
            dynamic leader */}
          </p>
        </div>
        <div className="w-full lg:w-[40%] px-10 flex items-center justify-center">
          <motion.img
            initial={{ opacity: 0.5, scale: 0.8, transform: "rotate(0deg)" }}
            whileInView={{ opacity: 1, scale: 1, transform: "rotate(360deg)" }}
            transition={{ duration: 5, ease: "easeInOut", repeat: Infinity }}
            viewport={{ once: false }}
            src={Thumbnail}
            alt="Section 2"
            className="max-w-full  lg:h-auto xl:h-auto md:h-[400px]"
          />
        </div>
      </section>

      <section
        className={`h-fit flex flex-col items-center justify-center rounded-xl gap-10 py-20 md:px-30 lg:px-28 xl:px-32 ${is2kViewed && "2xl:px-80"}`}
        style={{
          background:
            "radial-gradient(circle at right, rgba(21, 121, 246, 0.5) 0%, rgba(21, 121, 246, 0) 25%)",
          backdropFilter: "blur(347.1px)",
        }}
      >
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center "
        >
          Working with leading organizations
        </motion.h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 h-auto lg:grid-cols-4 xl:grid-cols-4 gap-10  place-items-center bg-white w-[90%] rounded-lg py-20">
          {[
            accentureLogo,
            nipponLogo,
            finfozLogo,
            mg2Logo,
            finfozLogo,
            mg2Logo,
            cyberLogo,
            buckmanLogo,
          ].map((item, index) => (
            <motion.img
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: false }}
              src={item}
              alt="icon"
              className="h-10 w-28 object-contain"
              key={index}
            />
          ))}
        </div>
      </section>
      <section className="h-fit py-20 flex flex-col items-center gap-10">
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center"
        >
          Empowering Innovation Across Industries
        </motion.h3>
        {/* <div id="circle">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="300px"
          height="300px"
          viewBox="0 0 300 300"
          enableBackground="new 0 0 300 300"
          xmlSpace="preserve"
        >
          <defs>
            <path
              id="circlePath"
              d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0"
            />
          </defs>
          <circle cx="150" cy="100" r="75" fill="none" />
          <g>
            <use xlinkHref="#circlePath" fill="none" />
            <text fill="#fff">
              <textPath xlinkHref="#circlePath">
                Text rotating around a circle path with SVG!
              </textPath>
            </text>
          </g>
        </svg>
      </div> */}

        <div className="video-container h-[500px] w-[70%] overflow-hidden relative rounded-lg group">
          {/* ReactPlayer for Video */}
          <ReactPlayer
            url={"https://www.youtube.com/watch?v=wdDKgO3wF00&t=22s"}
            height={"100%"}
            width={"100%"}
            playing={isPlaying}
            controls={false}
            onEnded={() => setIsPlaying(false)}
          />

          {!isPlaying ? (
            <div
              className="overlay absolute inset-0 flex items-center justify-center transition-opacity duration-300 ease-in-out rounded-lg"
              style={{
                background: "#00000066",
                backdropFilter: "blur(36px)",
              }}
            >
              <div className="rotating-text-container">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 300 300"
                >
                  <defs>
                    <path
                      id="circlePath"
                      d="M 150, 150 m -60, 0 a 60,60 0 1,1 120,0 a 60,60 0 1,1 -120,0"
                    />
                  </defs>
                  <text fill="#fff">
                    <textPath xlinkHref="#circlePath">
                      Sustainably&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Digitally&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Equality&nbsp;&nbsp;&bull;
                    </textPath>
                  </text>
                </svg>

                <button
                  className="center-button"
                  onClick={() => setIsPlaying(true)}
                >
                  <Play
                    fill="black"
                    className="h-16 w-16 p-5 bg-white rounded-full"
                    fontSize={12}
                    size={13}
                  />
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-black/50 absolute inset-0 hidden group-hover:flex flex-col items-center justify-center">
              <button
                className="center-button"
                onClick={() => setIsPlaying(false)}
              >
                <Pause
                  fill="black"
                  className="h-16 w-16 p-5 bg-white rounded-full"
                  fontSize={12}
                  size={13}
                />
              </button>
            </div>
          )}
        </div>
      </section>
      {/* <section className="min-h-screen flex flex-col items-center justify-between  lg:px-16 py-10 gap-5">
        <motion.h3
          initial={{ opacity: 0, translateY: -50 }}
          whileInView={{ opacity: 1, translayteY: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: false }}
          className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-center "
        >
          Here From our Satisfied clients have to say!
        </motion.h3>
        <div className="flex flex-col lg:flex-row gap-5 lg:w-[80%] w-full">
          <div
            className="lg:w-[40%] w-full lg:h-auto h-[480px] relative rounded-2xl "
            style={{
              backgroundImage: `url(${testmonialBg})`,
              backgroundPosition: "bottom center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <h5 className="text-white p-5 lg:text-base text-sm ">
              From inspiring teams to delivering exceptional results, these
              testimonials highlight the dedication, expertise, and integrity
              that define journey as a CEO.
            </h5>
            <img
              src={Imthyaz3}
              alt="imthyaz.png"
              className="absolute bottom-0 md:left-[15%] lg:left-0 "
            />
          </div>
          <div className="lg:w-[60%] w-full flex flex-col items-start overflow-hidden h-[auto]">
            <Slider {...settings}>
              {testimonialData.map((item) => (
                <motion.div
                  className="flex flex-col items-center justify-center  p-5 bg-[#101010] w-fit h-[200px] rounded-2xl my-5 py-8"
                  key={item.id}
                  initial={{ opacity: 0, scale: 0.5 }}
                  whileInView={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.5, y: -50 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  layout
                >
                  <p className="text-sm">{item.review}</p>
                  <div className="flex flex-row gap-5 items-center justify-between">
                    <div className="flex flex-row gap-5 items-center  w-full my-5">
                      <img
                        src={item.authorImg}
                        alt="author.png"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h5 className="text-base font-medium">{item.name}</h5>
                        <h6 className="text-[12px] font-normal">
                          {item.designation}
                        </h6>
                      </div>
                    </div>
                    <div>
                      <svg
                        fill="#575757"
                        stroke="none"
                        className="h-10 w-10"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 0l8 8-8-8z"></path>
                      </svg>
                    </div>
                  </div>
                </motion.div>
              ))}
            </Slider>
          </div>
        </div>
      </section> */}
      <section
        className={` py-10    px-10 md:px-30 lg:px-20 xl:px-44 ${is2kViewed && "2xl:px-80"}`}
        ref={contactRef}
      >
        <div className="flex flex-col items-start justify-between gap-5 rounded-2xl bg-[#101010] px-2 md:px-10 py-10">
        <h3 className="text-3xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-left">
          Let's Start a{" "}
          <span
          // style={{
          //   background: "linear-gradient(90deg, #191991 0%, #B7B7F8 100%)",
          //   WebkitBackgroundClip: "text",
          //   WebkitTextFillColor: "transparent",
          // }}
          >
            Conversation
          </span>
        </h3>

        <div className="flex lg:flex-row flex-col gap-5 items-center w-full ">
          <div className="lg:w-1/2  w-full">
            <img
              src={contactbg}
              alt="contact.png"
              className="rounded-2xl h-[450px] w-full object-cover"
            />
          </div>
          <div className="lg:w-1/2 w-full relative overflow-hidden ">
            <form
              className="max-w-full space-y-8 h-full "
              onSubmit={handleSubmit}
            >
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="First Name"
                  className="w-full p-3 bg-[#080808] border border-transparent rounded text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
                />
                {errors.name && (
                  <p className="text-red-600 text-[12px] mt-1">{errors.name}</p>
                )}
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full p-3 bg-[#080808] borderborder-transparent rounded text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
                />
                {errors.email && (
                  <p className="text-red-600 text-[12px] mt-1">
                    {errors.email}
                  </p>
                )}
              </div>
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="w-full p-3 bg-[#080808] borderborder-transparent rounded text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
                />
                {errors.phone && (
                  <p className="text-red-600 text-[12px] mt-1">
                    {errors.phone}
                  </p>
                )}
              </div>
              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your message here . . ."
                  className="w-full p-3 bg-[#080808] borderborder-transparent rounded text-white placeholder-gray-500 focus:outline-none focus:border-blue-500"
                  rows="4"
                ></textarea>
                {errors.message && (
                  <p className="text-red-600 text-[12px] mt-1">
                    {errors.message}
                  </p>
                )}
              </div>
              <button
                type="submit"
                className="w-full py-3 bg-[#191991] relative rounded-xl text-white font-semibold  transition duration-300 group overflow-hidden"
              >
                <div className="absolute inset-0 bg-white/20 w-0 group-hover:w-full transition-all duration-500 ease-in-out overflow-hidden"></div>
                Submit
              </button>
            </form>
            {status === "loading" && (
              <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center gap-5">
                <motion.div
                  initial={{ opacity: 0.5, rotate: 0 }}
                  animate={{ opacity: 1, rotate: 360 }}
                  transition={{
                    duration: 3,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <Loader size={54} fill="#4BB543" />
                </motion.div>
                <h3 className="text-base font-semibold">
                  Sending message . . .
                </h3>
              </div>
            )}
            {status === "success" && (
              <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center gap-5">
                <motion.div
                  initial={{ opacity: 0.5, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 1.5,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <CircleCheckBig size={54} fill="#4BB543" />
                </motion.div>
                <h3 className="text-base font-semibold">
                  Your message has been sent successfully
                </h3>
              </div>
            )}
            {status === "error" && (
              <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center gap-5">
                <motion.div
                  initial={{ opacity: 0.5, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 1.5,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                  }}
                >
                  <CloudAlert size={54} stroke="#FF0000" />
                </motion.div>
                <h3 className="text-base font-semibold capitalize">
                  Something went wrong please try again later
                </h3>
              </div>
            )}
          </div>
        </div>
        </div>
        
      </section>
    </div>
    <Footer sectionRef={{journeyRef,awardsRef,expertiseRef,contactRef}} is2kView={is2kViewed}/>
    </>
  );
};

export default Home;
